import React from "react";

export default function Contact() {
  return <h1> Come Back Later! </h1>;
}
